import {Component} from '@angular/core';
import {ThemeCustomizerService} from '../theme-customizer/theme-customizer.service';

@Component({
    standalone: true,
    selector: 'app-whatsapp-support',
    imports: [],
    templateUrl: './whatsapp-support.component.html',
    styleUrl: './whatsapp-support.component.scss'
})
export class WhatsappSupportComponent {

    isShow: boolean = false;
    topPosToStartShowing = 100;
    isToggled = false;

    constructor(
        public themeService: ThemeCustomizerService
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }


    redirectToWhatsApp(): void {
        const phoneNumber = '919828430980'; // Your company's WhatsApp number in international format
        const message = 'Hi there! I’m interested in learning more about your services. Could you please share some details? Thank you!';
        const encodedMessage = encodeURIComponent(message); // URL-encode the message
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
        window.open(whatsappUrl, '_blank', "noopener,noreferrer"); // Open WhatsApp in a new tab
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

}
